// extracted by mini-css-extract-plugin
export default {"note":"KeyPeopleInPortfolio_note__AV2zo","ctaAdd":"KeyPeopleInPortfolio_ctaAdd__qtSSU"};